// Quantity validator for the product page.
// Enforces min/max on the quantity input, clamps invalid values on blur,
// disables Add to Cart while the value is out of range, and blocks form
// submission as a last-resort safety net. No visual output.

(function () {
  function wireSection(productInfo) {
    const sectionId = productInfo && productInfo.dataset && productInfo.dataset.section;
    if (!sectionId) return;

    const qtyInput = productInfo.querySelector(`#Quantity-${sectionId}`);
    if (!qtyInput || qtyInput.dataset.qtyValidatorWired === 'true') return;
    qtyInput.dataset.qtyValidatorWired = 'true';

    const submitBtn = productInfo.querySelector(`#ProductSubmitButton-${sectionId}`);
    const form = productInfo.querySelector(`#product-form-${sectionId}`);

    function readBounds() {
      const min = parseInt(qtyInput.min, 10) || 1;
      const maxAttr = parseInt(qtyInput.max, 10);
      const max = isNaN(maxAttr) ? Infinity : maxAttr;
      const raw = qtyInput.value.trim();
      const parsed = parseInt(raw, 10);
      const qty = raw === '' || isNaN(parsed) ? NaN : parsed;
      return { qty, min, max };
    }

    function clamp() {
      const { min, max } = readBounds();
      const raw = qtyInput.value.trim();
      let val = parseInt(raw, 10);
      if (raw === '' || isNaN(val) || val < min) val = min;
      if (val > max) val = max;
      if (String(val) !== qtyInput.value) {
        qtyInput.value = val;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function setSubmitValidity(isValid) {
      if (!submitBtn) return;
      if (isValid) {
        if (submitBtn.dataset.qtyDisabled === 'true') {
          submitBtn.removeAttribute('disabled');
          delete submitBtn.dataset.qtyDisabled;
        }
      } else if (!submitBtn.hasAttribute('disabled')) {
        submitBtn.setAttribute('disabled', '');
        submitBtn.dataset.qtyDisabled = 'true';
      }
    }

    function update() {
      const { qty, min, max } = readBounds();
      const valid = !isNaN(qty) && qty >= min && qty <= max;
      setSubmitValidity(valid);
    }

    qtyInput.addEventListener('input', update);
    qtyInput.addEventListener('change', update);
    qtyInput.addEventListener('blur', () => {
      clamp();
      update();
    });

    if (form) {
      form.addEventListener(
        'submit',
        (event) => {
          clamp();
          const { qty, min, max } = readBounds();
          if (isNaN(qty) || qty < min || qty > max) {
            event.preventDefault();
            event.stopImmediatePropagation();
            qtyInput.focus();
          }
        },
        true
      );
    }

    update();
  }

  function wireAll() {
    document.querySelectorAll('product-info').forEach(wireSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireAll);
  } else {
    wireAll();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      setTimeout(wireAll, 0);
    });
  }
})();
